import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import EcCommon from '../../../types/ec/ecCommon';
import moment from 'moment';

export const PlanServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'enterprise-coach/plan',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class PlanService extends ApiService implements EcCommon.IPlanService {
	constructor() {
		super('plan-service', PlanServiceAxiosInstance);
	}

	public getFreePrograms(partyId: number): AxiosPromise<EcCommon.IFreeProgram[]> {
		return this.axiosInstance.get('/freeProgram/employee/partyId/' + partyId);
	}

	public createFreeProgram(partyId: number, request: EcCommon.IFreeProgramRequest): AxiosPromise<EcCommon.IFreeProgram> {
		return this.axiosInstance.post('/freeProgram/employee/partyId/' + partyId, this.preProcessRequest(request));
	}

	public getProgramListforMember(partyId: number): AxiosPromise<EcCommon.IProgram[]> {
		return this.axiosInstance.get('/program/partyId/' + partyId);
	}

	public updateFreeProgram(partyId: number, request: EcCommon.IFreeProgramRequest): AxiosPromise<EcCommon.IFreeProgram> {
		return this.axiosInstance.put('/freeProgram/employee/partyId/' + partyId, this.preProcessRequest(request));
	}

	public startProgram(partyId: number, sourceId: string, programType: string): AxiosPromise<EcCommon.ITrainerizeToken> {
		return this.axiosInstance.post('/program/start/member/' + partyId + '/program/' + sourceId + '/programtype/' + programType + '/startdate/' + moment().format('M-D-Y'));
	}

	public postSwitchProgram(partyId: number, sourceId: string, programType: string): AxiosPromise<EcCommon.ITrainerizeToken> {
		return this.axiosInstance.post('/program/switch/member/' + partyId + '/program/' + sourceId + '/programtype/' + programType + '/startdate/' + moment().format('M-D-Y'));
	}

	private preProcessRequest(input: EcCommon.IFreeProgramRequest): EcCommon.IFreeProgramRequest {
		let featured: boolean;

		if (typeof input.featured === 'boolean') {
			featured = input.featured;
		} else {
			featured = input.featured === 'true';
		}

		const response: EcCommon.IFreeProgramRequest = {
			freeProgramId: input.freeProgramId ? Number(input.freeProgramId) : 0,
			programId: Number(input.programId),
			programImage: input.programImage,
			programName: input.programName,
			programDescription: input.programDescription,
			featured,
			priority: Number(input.priority),
			frequency: input.frequency,
			duration: input.duration,
			equipment: input.equipment || '',
			exercise: input.exercise || '',
			level: input.level,
			goal: input.goal,
			isActive: input.isActive,
		};

		if (input.endDate) {
			response.endDate = moment(input.endDate).format();
		}

		return response;
	}
}

export const planService = new PlanService();
